import React from 'react';
import { toast } from 'react-hot-toast';
import { Toast } from './Toast';
const showToast = ({
  message,
  Actions,
  alignContent,
  id,
  duration,
  hasIcon,
  customIcon,
  color,
  loading,
  onClose
}) => toast.custom(t => <Toast color={color} toast={t} message={message} Actions={Actions} onClose={() => onClose ? onClose() : toast.dismiss(t.id)} alignContent={alignContent} hasIcon={hasIcon} customIcon={customIcon} loading={loading} />, {
  id,
  duration
});

// Specific toast functions
export const showSuccessToast = props => showToast({
  ...props,
  color: 'success'
});
export const showErrorToast = props => showToast({
  ...props,
  color: 'danger'
});
export const showInfoToast = props => showToast({
  ...props,
  color: 'primary'
});
export const showWarningToast = props => showToast({
  ...props,
  color: 'warning'
});
export const showSecondaryToast = props => showToast({
  ...props,
  color: 'secondary'
});
export const dismissToast = id => toast.dismiss(id);